import React from 'react';

const RefundPolicy: React.FC = () => {
  return (
    <div className="pt-16 bg-white min-h-screen">
      {/* Page Title */}
      <div className="bg-white text-gray-800 py-12">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-[#2b603e] to-[#1a3d25]">Return Policy</h1>
          <p className="text-xl max-w-3xl mx-auto text-gray-600">
            Important guidelines for product returns and refunds at Asclepius.
          </p>
        </div>
      </div>

      {/* Divider */}
      <div className="container mx-auto px-4">
        <hr className="border-t border-gray-200 my-0" />
      </div>

      {/* Return Policy Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="space-y-8">
            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Return Policy Guidelines</h2>
              <ul className="list-disc list-inside text-gray-600 space-y-4">
                <li>
                  <strong>Return Period:</strong> Customers have the right to notify Asclepius of a return within <strong>14 days</strong> of receiving the product, in accordance with Dutch consumer law.
                </li>
                <li>
                  <strong>Product Condition:</strong> Due to hygiene and safety reasons, only unopened and unused products in their original packaging are eligible for return and refund.
                </li>
                <li>
                  <strong>Return Notification:</strong> To initiate a return, customers must contact Asclepius within 14 days of receipt.
                </li>
                <li>
                  <strong>Return Shipping Costs:</strong> Return shipping costs are the responsibility of the customer unless the return is due to an error on Asclepius’s part.
                </li>
                <li>
                  <strong>Return Shipping Liability:</strong> Asclepius is not liable for any loss or damage that occurs during the return shipment. We recommend using a tracked and insured shipping method.
                </li>
                <li>
                  <strong>Refund Processing:</strong> Refunds will be processed within 14 days after we receive and inspect the returned product.
                </li>
                <li>
                  <strong>Product Inspection and Refusal:</strong> Products that show signs of use, tampering, or have been opened will be refused for return and may be returned to the customer or destroyed.
                </li>
                <li>
                  <strong>Right to Refuse Returns:</strong> Asclepius reserves the right to refuse returns that do not meet these conditions.
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact Information</h2>
              <p className="text-gray-600">
                For any questions regarding our Return Policy, please contact:
                <br />
                <strong>Email:</strong> info@asclepius-shilajit.com
                <br />
                <strong>Phone:</strong> +31 657945978
                <br />
                <strong>Customer Service Hours:</strong> Monday to Friday, 09:00–17:00
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RefundPolicy;
